<div class="enkelleermiddelactivatieofgebruik">
  <span>{{ leermiddelinfo.leermiddelNaam }}</span>
    <canvas baseChart
      [data]="doughnutChartData"
      [labels]="doughnutChartLabels"
      [options]="doughnutChartOptions"
      [plugins]="doughnutChartPlugins">
    </canvas>
</div>
